import React from 'react';
import PropTypes from 'prop-types';

// TODO move to common namespace
import Carousel from 'components/Carousel/Carousel';

function TabCarouselContent({
  selectedTabIndex,
  updateTabIndex,
  componentsArray,
}) {
  return (
    <Carousel
      onStepChanged={step => updateTabIndex(step - 1)}
      currentStep={selectedTabIndex + 1}
      showControls={false}
    >
      {componentsArray}
    </Carousel>
  );
}

TabCarouselContent.propTypes = {
  componentsArray: PropTypes.node.isRequired,
  selectedTabIndex: PropTypes.number.isRequired,
  updateTabIndex: PropTypes.func.isRequired,
};

export default TabCarouselContent;
